import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { LocalDataSource } from 'ng2-smart-table';
import { History } from '@app/flow/flow.component';
import { ToastrService } from 'ngx-toastr';
import { ActividadDeault, BaseControl, Categoria, ConfirmComponent, Const, DynamicFormComponent, Proceso, SuspensionTiempoApi, Tarea, TramiteDefaultCorto } from '@app/shared';
import { TimeSuspensionsDataService } from './shared/time-suspensions.data.service';
import { TimeSuspensionsConfigService } from './shared/time-suspensions.config.service';
import { TimeSuspensionsFormService } from './shared/time-suspensions.form.service';
import { ProcessAutomationComponent } from '@app/administration/process-automation/process-automation.component';
import { Subscription } from 'rxjs';
import { NotifierService } from '@app/shared/services/notifier.service';

// Define las acciones posibles para una tarea o actividad
type actionManage = 'select' | 'run';

export interface InfoSuspension {
  id: number;
  tramite_id: number;
  tramite_nombre: string;
  tarea_id: number;
  tarea_nombre: string;
  actividad_id: number;
  actividad_nombre: string;
  datos_formulario: any;
  finaliza_suspension: boolean;
  tarea_actividad: string;
  tipo_configuracion: string;
  delete: boolean;
  update: boolean;
  detail: boolean;
}

const log = new Logger('TimeSuspensionsComponent');
@Component({
  selector: 'iw-time-suspensions',
  templateUrl: './time-suspensions.component.html',
  styleUrls: ['./time-suspensions.component.scss'],
  providers: [
    TimeSuspensionsDataService,
    TimeSuspensionsFormService,
    NotifierService
  ]
})
export class TimeSuspensionsComponent implements OnInit {

  // Define cuando mostrar el ghostBox
  ghostBox = true;
  // Define cuando se esta cargando un flujo
  isLoadingFlow = false;
  // Pregunta de la modal de confirmaciones
  question = '';
  // Historial de las decisiones del usuario en los filtros de las tablas default
  history: History = new History();
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Contiene el id del grupo seleccionado
  idTramiteSelect = -1;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
  };
  // Define cuando mostrar la tabla Ver detalles de la etapa
  formViewOpen = false;
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // contiene la informacion de las etapas
  source: InfoSuspension[];
  // Contiene la informacion de la suspension seleccionada
  timeSuspensionSelect: InfoSuspension;
  // Contiene el id del grupo seleccionado
  idSuspensionSelect = -1;
  // Define si el rol en accion es para editar o agregar
  rolEdit = true;
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Contiene los controles de el formulario de configuración por formulario de la tarea
  controlsTaskForm: BaseControl<any>[] = [];
  // Contiene los controles de el formulario de configuración por condición de la tarea
  controlsTaskCondition: BaseControl<any>[] = [];
  // Contiene los controles cuando la suspención no tiene configuración asociada
  controlsWithoutConfig: BaseControl<any>[] = [];
  // Tipo de formulario para la suspensión
  formType: string = '';
  // backup del component select tramite
  stComponent: SelectTramiteComponent;
  // Contiene la tarea Seleccionada
  taskSelect: Partial<Tarea>;
  // Contiene la tarea cargada
  taskLoaded: Partial<Tarea>;
  // Contiene la actividad Seleccionada
  activitySelect: Partial<ActividadDeault>;
  // Contiene la actividad Seleccionada
  activityAsTarea: Partial<Tarea>;
  // Contiene el id de la actividad Seleccionada
  idActivitySelect: number;
  // Contiene el id de la tarea Seleccionada
  idTaskSelect: number;
  // Muesta u oculta el flow
  viewFlow: boolean;
  // Muestra el titulo del flow
  configFlowTitle: boolean;
  // Historial de consulta del tramite seleccionado
  historyFlow: Array<number> = [];
  // Suscripción a las notificaciones de otros componentes
  private notifications: Subscription;
  // Indica si se debe mostrar el mensaje de error de la tarea
  showTaskError = false;
  // Componente select-tramite
  @ViewChild(SelectTramiteComponent) stcRef: SelectTramiteComponent;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia al componente del proceso
  @ViewChild('iwProcessAutomation') iwProcessAutomation: ProcessAutomationComponent;
  constructor(
    private as: AuthenticationService,
    private toastr: ToastrService,
    private tsds: TimeSuspensionsDataService,
    private tsfs: TimeSuspensionsFormService,
    private ns: NotifierService,
  ) { }

  ngOnInit() {
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.delete,
    );

    const configTable = new TimeSuspensionsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });

    this.notifications = this.ns.get().subscribe(async (n: any) => {
      // Definir la acción que se quiere hacer con la tarea
      let action: actionManage;
      // Si se ejecutó el evento click en una tarea
      if (n.source === 'task') {
        switch (n.action) {
          case 'selectTask':
            action = 'select';
            this.showTaskError = false;
            this.taskSelect = n.data.task;
            this.idTaskSelect = n.data.task.id;
            this.taskLoaded = n.data.task;
            this.activityAsTarea = null;
            this.activitySelect = null;
            this.idActivitySelect = null;
            this.historyFlow = [];
            this.viewFlow = false;
            this.isLoadingFlow = false;
            this.configFlowTitle = null;
            this.ghostBox = false;
            this.iwProcessAutomation.toggleCompletionMode(false);
            break;
          case 'runMicroProcess':
            action = 'run';
            break;
        }
      }
    });
  }

  /**
   * controla el historial de cambios de los selectores categoria, proceso y tramite
   *
   * @memberof TimeSuspensionsComponent
   */
  ngAfterViewInit() {
    this.history.active = true;
    // Vigilar los cambios que se producen en los selects de categoria, proceso y tramite.
    this.stcRef.dataObserver.subscribe((change: any) => {
      if (change.target === 'category') {
        this.history.category = change.data as Categoria;
      }
      if (change.target === 'process') {
        this.history.process = change.data as Proceso;
      }
      if (change.target === 'tramite') {
        this.history.tramite = change.data as TramiteDefaultCorto;

      }
    });
  }

  /**
   * Carga la información de las suspensiones
   *
   * @memberof TimeSuspensionsComponent
   */
  loadingTimeSuspensionDetail() {
    this.idTramiteSelect = this.history.tramite.id;
    this.source = [];
    if (this.activateAction.review) {
      this.tsds.getTimeSuspensionsDetail(this.idTramiteSelect).subscribe(
        timeSuspensions => {
          this.source = timeSuspensions.map(ts => {
            return {
              id: ts.id,
              tramite_id: ts.tramite.id,
              tramite_nombre: ts.tramite.nombre,
              tarea_id: ts.tarea.id,
              tarea_nombre: ts.tarea.nombre,
              actividad_id: ts.tarea.actividad_id,
              actividad_nombre: ts.tarea.actividad,
              datos_formulario: ts.datos_formulario,
              finaliza_suspension: ts.finaliza_suspension,
              tarea_actividad: `Tarea: ${ts.tarea.nombre}, Actividad: ${ts.tarea.actividad}`,
              delete: this.activateAction.delete,
              update: this.activateAction.update,
              // Desactivar boton "Detalles"
              detail: true,
              tipo_configuracion: ts.datos_formulario.alias_formulario ? 'Formulario de la tarea' : ts.datos_formulario.alias_condicion ? 'Condición de la tarea' : 'Sin datos'
            }
          });
          this.sourceData = new LocalDataSource(this.source);
        }
      )
    } else {
      this.toastr.error('Usted no posee permisos para ver el detalle de las etapas del tramite', 'Permiso denegado');
    }
  }

  /** Controla las diferentes acciones de agregar, modificar o eliminar
  *
  * @param {('add' | 'update' | 'delete')} [action='add']
  * @param {*} [data]
  * @memberof TimeSuspensionsComponent
  */
  async defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action.toString()) {
      case 'add':
        if (this.activateAction.created) {
          this.stComponent = this.stcRef;
          this.formOpen = true;
          this.rolEdit = false;
          this.actionForm = 'Agregar';
          this.backupDataSelectTramiteComponent();
        } else {
          this.toastr.error(
            'Usted no posee permisos para agregar detalles de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          this.taskLoaded = await this.tsds.getTask(data.tarea_id);
          this.taskSelect = this.taskLoaded;
          this.idTaskSelect = data.tarea_id;
          this.ghostBox = false;
          this.formOpen = true;
          this.rolEdit = true;
          this.actionForm = 'Modificar';
          this.timeSuspensionSelect = data;
          this.backupDataSelectTramiteComponent();
          this.formType = this.getFormType(this.timeSuspensionSelect.datos_formulario);
          this.formTypeSelected(this.formType);
        } else {
          this.toastr.error(
            'Usted no posee permisos para modificar las suspensiones en el sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.timeSuspensionSelect = data;
          this.question = '¿Realmente desea eliminar la suspensión?';
          this.confirm.open();
        } else {
          this.toastr.error(
            'Usted no posee permisos para eliminar la suspensión en el sistema',
            'Permiso denegado'
          );
        }
        break;
    }
  }

  /**
   * Almacena el tipo del formulario de la suspensión seleccionado
   * 
   * @memberof TimeSuspensionsComponent
   */
  formTypeSelected(data: any) {
    this.formType = typeof data === 'string' ? data : data.target.value;
    if (this.formType === 'formulario') {
      this.controlsTaskForm = this.tsfs.getFormSuspensionByTaskForm(this.timeSuspensionSelect);
    } else if (this.formType === 'condicion') {
      this.controlsTaskCondition = this.tsfs.getFormSuspensionByTaskCondition(this.timeSuspensionSelect);
    } else if(this.formType === 'sin_configuracion') {
      this.controlsWithoutConfig = this.tsfs.getFormSuspension(this.timeSuspensionSelect);
    }
  }

  /**
   * Cierra el formulario o reinicia el componente a la tabla principal
   *
   * @memberof TimeSuspensionsComponent
   */
  closeFormTimeSuspensions() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.timeSuspensionSelect = null;
    this.timeSuspensionSelect = null;
    this.idTramiteSelect = null;
    this.idSuspensionSelect = null;
    this.taskSelect = null;
    this.idTaskSelect = null;
    this.activitySelect = null;
    this.idActivitySelect = null;
    this.ghostBox = true;
    this.taskLoaded = null;
    this.formType = '';
    this.controlsTaskCondition = [];
    this.controlsTaskForm = [];
    this.controlsWithoutConfig = [];
    this.showTaskError = false;
  }

  /**
   * Controla la accion de confimacion del modal
   *
   * @param {boolean} res
   * @memberof TimeSuspensionsComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteSuspension();
    }
    this.question = '';
  }

  loadFlow() {
    this.iwProcessAutomation.flowMode = 'etapas';
    this.iwProcessAutomation.selectedDefaultTramite();
  }

  activityToTask() {
    log.debug(`activitySelect= ${this.activitySelect.tareas}`);
    const activityT = {
      activo: false,
      descripcion: this.activitySelect.descripcion,
      fecha_registro: null,
      id: this.activitySelect.id,
      meta: null,
      nombre: this.activitySelect.nombre,
      orden: this.activitySelect.orden,
      rechazable: null,
      tarea_actividad: this.activitySelect.id,
      tarea_forma: null,

    } as Partial<Tarea>;
    this.activityAsTarea = activityT;
  }

  sended(data: any) {
    if (data) {
      if(!this.idTaskSelect) {
        this.showTaskError = true;
        return;
      }

      let suspension: any = {
        tarea: this.idTaskSelect,
        finaliza_suspension: data.finaliza_suspension
      };
      // Añadir "datos_formulario" al objeto suspension
      let datos_formulario: any = {}
      if (this.formType === 'formulario') {
        datos_formulario = {
          alias_formulario: data.alias_formulario,
          fecha: data.fecha,
          motivo: data.motivo
        }
      } else if (this.formType === 'condicion') {
        datos_formulario = {
          alias_condicion: data.alias_condicion,
          // Dividir string por ',' de las opciones ingresadas
          opcion: data.opcion.toString().split(',').map((o: any) => o.trim())
        }
      }

      suspension = {
        ...suspension,
        datos_formulario: datos_formulario
      };

      if (this.rolEdit) {
        log.debug(this.timeSuspensionSelect.id);
        this.tsds.updateTimeSuspension(this.timeSuspensionSelect.id, suspension).then(() => {
          this.loadingTimeSuspensionDetail();
          this.closeFormTimeSuspensions();
        }).catch(() => {
          this.closeFormTimeSuspensions();
        });
      } else {
        this.tsds.addTimeSuspension(suspension).then(() => {
          this.loadingTimeSuspensionDetail();
          this.closeFormTimeSuspensions();
        }).catch(() => {
          this.closeFormTimeSuspensions();
        });
      }
    }
  }

  /**
   * Elimina una suspensión
   *
   * @private
   * @memberof TimeSuspensionsComponent
   */
  private deleteSuspension() {
    this.tsds.deleteTimeSuspension(this.timeSuspensionSelect.id).then(() => {
      this.loadingTimeSuspensionDetail();
      this.closeFormTimeSuspensions();
    }).catch(() => {
      this.closeFormTimeSuspensions();
    });
  }

  /**
    * Guardar copia de los datos de SelectTramiteComponent
    *
    * @private
    * @memberof TimeSuspensionsComponent
    */
  private backupDataSelectTramiteComponent() {
    const backup = this.stcRef.getAll();
    for (const key in backup) {
      if (backup.hasOwnProperty(key)) {
        this.history[key] = backup[key];
      }
    }
  }

  private getFormType(data: any) {
    return data.alias_formulario ? 'formulario' : data.alias_condicion ? 'condicion' : 'sin_configuracion';
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/time-suspensions/time-suspensions.component.ts